import {
  cellStyles,
  type ICellRendererParams,
  renderDashOr,
} from "@/shared/foundation/primitives/Table";

/**
 * A description cell: one muted line that ellipsizes, with the full text in a
 * tooltip. An empty value renders the shared em-dash. Pair with
 * {@link DESCRIPTION_COLUMN_SIZING} so the column can't squeeze its neighbours.
 */
export const renderDescription = renderDashOr((params: ICellRendererParams) => {
  const text = String(params.value);
  return (
    <span className={cellStyles.description} title={text}>
      {text}
    </span>
  );
});

/** The width rules every list's Description column shares. */
export const DESCRIPTION_COLUMN_SIZING = {
  flex: 2,
  minWidth: 240,
  maxWidth: 420,
} as const;
